export default "__VITE_ASSET__CTizc5ud__"